import * as React from "react";
import { observer } from "mobx-react";
import { Translation } from "./translation";
import { I18nService, I18nServiceContext } from "../services/i18n/i18n-service";

export interface TransProps {
  children?:
    | ((token: string) => React.ReactNode | Translation)
    | Translation
    | string;
  token?: Translation | string;
  values?: {
    [key: string]: any;
  };
}

@observer
export class Trans extends React.Component<TransProps> {
  public static contextType = I18nServiceContext;

  constructor(props: TransProps, public context: I18nService) {
    super(props, context);
  }

  public interpolate() {
    if (this.props.children instanceof Translation)
      return this.props.children.interpolate(this.props.values);

    if (this.props.token instanceof Translation)
      return this.props.token?.interpolate(this.props.values) || "";

    if (typeof this.props.children === "string") return this.props.children;

    if (typeof this.props.token === "string") return this.props.token;

    return "";
  }

  public render(): React.ReactNode | string {
    const { children } = this.props;
    const interpolated = this.interpolate();

    return typeof children === "function"
      ? children(interpolated)
      : interpolated;
  }
}
